export default "__VITE_ASSET__CRIunFSU__"